import React, { Component } from "react";
import Support from "../../../components/Support/Support";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SupportForm
Description : Componente que invoca al componente Support, para la creación y consulta de reportados.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Reported
================================================================================ */
class SupportForm extends Component{
    render(){
        return(
            <Support/>  
        )   
    }
}

export default SupportForm;